import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface BulkOrderDetailsInterface {
  reference: string
  consNo?: any
  carrierService?: any
  status?: any
}

export const useGetBulkOrderConsignmentDetails = () => {
  const mutate = useMutation(
    ({
      reference,
      consNo,
      carrierService,
      status,
    }: BulkOrderDetailsInterface) => {
      return postAPI(`PWBulkConsignment/GetBulkOrderDetails`, {
        reference,
        consNo,
        carrierService,
        status,
      })
    },
  )

  return mutate
}

export default useGetBulkOrderConsignmentDetails
